<script>
import { iTooltip } from '@inscribe/signal';

export default {
  components: {
    iTooltip,
  },
  props: {
    tooltipData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="d-flex align-items-center">
    <span>{{ tooltipData.value }}</span>
    <span
      v-if="tooltipData.showTooltip"
      :id="tooltipData.tooltipId"
      class="i-ml-2 i-text-neutral-100"
      style="cursor: help"
    >
      N/A
    </span>
    <i-tooltip
      v-if="tooltipData.showTooltip"
      :target="'#' + tooltipData.tooltipId"
      :title="tooltipData.tooltipText"
    />
  </div>
</template>
